import { render } from "./LoaderDiv.vue?vue&type=template&id=31d6142c&scoped=true"
import script from "./LoaderDiv.vue?vue&type=script&lang=js"
export * from "./LoaderDiv.vue?vue&type=script&lang=js"

import "./LoaderDiv.vue?vue&type=style&index=0&id=31d6142c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d6142c"]])

export default __exports__